import { Navigate, useLocation } from '@/util/react-router-dom';
import { Brand } from '../outlets/branding-outlet';

interface BrandRedirectProps {
  brand: Brand;
}

export function BrandRedirect({ brand }: BrandRedirectProps) {
  const location = useLocation();

  return (
    <Navigate
      to={`/${brand}${location.pathname}${location.search}${location.hash}`}
      replace
      doNotResolveBrandingPath
    />
  );
}
